<div class="mat-body">
    <button type="button" class="btn-close mat-elevation-z0" mat-icon-button [mat-dialog-close]="false">
        <mat-icon>close</mat-icon>
    </button>
    <p class="mat-headline text-center mb-4" *ngIf="data.title" [innerHTML]="data.title|translate"></p>
    <p [innerHTML]="data.text|translate"></p>

    <div class="row justify-content-center">
        <div class="col-12 col-sm-6 mt-4">
            <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" [mat-dialog-close]="true">
                <span *ngIf="data.ok" [translate]="data.ok"></span>
                <span *ngIf="!data.ok">{{ 'general.accept'|translate }}</span>
            </button>
        </div>
    </div>
</div>
